var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-calendar',{attrs:{"type":"day","hide-header":"","start":"2000-01-01","events":_vm.processedEvents,"interval-height":_vm.intervalHeight},on:{"click:event":_vm.eventClicked},scopedSlots:_vm._u([{key:"event",fn:function(ref){
var event = ref.event;
return [_c('div',{staticClass:"event-body-container text-center"},[_c('label',{staticClass:"event-body-label"},[_vm._v(_vm._s(event.name))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }